























































import Vue from "vue";
import EventPreview from "@/components/arma/events/EventPreview.vue";
import EventCalendar from "@/components/arma/events/EventCalendar.vue";
import { AxiosRequestConfig } from "axios";
import {
  DateTimeInterface,
  LoggedInDiscordUser,
  PersistedEventInterface,
  CalendarPeriod,
} from "@/types";
import User from "@/User";
import moment from "moment-timezone";
import EventService from "@/classes/EventService";

export default Vue.extend({
  metaInfo() {
    return {
      title: "Events – Newfound Pioneer Corps Arma 3",
      meta: [
        { vmid: "description", name: "description", content: "Sign up for one of our events by checking out our event calendar. All dates are shown in your local timezone and can be joined by the click of a button." },
        { vmid: "og:title", property: "og:title", content: "Events – Newfound Pioneer Corps Arma 3" },
        { vmid: "og:description", property: "og:description", content: "Sign up for one of our events by checking out our event calendar. All dates are shown in your local timezone and can be joined by the click of a button." },
        { vmid: "og:url", property: "og:url", content: "https://arma.npcs.games/events" },
      ],
    };
  },
  components: {
    EventPreview,
    EventCalendar,
  },
  data() {
    return {
      events: [] as PersistedEventInterface[],
      futureEvents: [] as PersistedEventInterface[],
      endpoint: "/arma/events",
      tab: null,
      period: {} as CalendarPeriod,
    };
  },
  async created() {
    this.events = await this.getEvents({});
    this.getFutureEvents(this.events);
  },
  methods: {
    setPeriodParams(period: CalendarPeriod) {
      let periodStart = moment
        .utc()
        .startOf("month")
        .subtract(5, "days")
        .format("YYYY-MM-DD");
      let periodEnd = moment
        .utc()
        .endOf("month")
        .add(5, "days")
        .format("YYYY-MM-DD");
      if (period && Object.keys(period).length) {
        periodStart = moment
          .utc(period.start)
          .subtract(35, "days")
          .format("YYYY-MM-DD");
        periodEnd = moment.utc(period.end).add(35, "days").format("YYYY-MM-DD");
      }
      return {
        "date[gte]": periodStart,
        "date[lte]": periodEnd,
      };
    },
    async updateEvents(period: CalendarPeriod) {
      this.events = await this.getEvents(period);
    },
    async getEvents(
      period: CalendarPeriod
    ): Promise<PersistedEventInterface[]> {
      const self = this;
      this.parameterObject.params = {
        ...this.parameterObject.params,
        ...this.setPeriodParams(period),
      };
      const response = await this.axios.get(
        this.endpoint,
        this.parameterObject
      );

      if (!response.data) {
        this.$store.dispatch("showErrorSnackbar", "No data returned from the server.");
        return [];
      }

      return response.data;
    },
    async getFutureEvents(events: PersistedEventInterface[]) {
      this.futureEvents = await EventService.getFutureEvents(events);
    },

    createNewEvent() {
      localStorage.removeItem("copyEvent");
      this.$router.push("/events/create");
    },
  },
  computed: {
    parameterObject(): AxiosRequestConfig {
      return {
        params: {
          "sort[asc]": "date",
        },
      };
    },
    user(): LoggedInDiscordUser | null {
      return User.get();
    },
  },
});
